import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { localize } from 'react-localize-redux';

import SinNumberFormField from 'components/shared/SinNumberFormField';

import * as formatter from 'helpers/Formatter';
import * as validator from 'helpers/Validator';
import { deepDiver } from 'helpers/utilities';
import { hostIsCapreit } from 'helpers/CurrentWindowLocation';
import { Field } from 'redux-form';
import DatePickerAccessible from 'helpers/reduxFormMaterialUiNext/DatePickerAccessible';
import MenuItem from '@material-ui/core/MenuItem';
import { BooleanRadioButtons } from 'helpers/BooleanRadioButtons';
import { maxDate } from 'helpers/Formatter';
import ReactPhoneInput from 'helpers/reduxFormMaterialUiNext/ReactPhoneInput';
import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import OutlinedSelect from 'helpers/reduxFormMaterialUiNext/OutlinedSelect';
import { getTranslatedString } from 'helpers/i18n';
import { SALARY_RANGES } from 'constants/salaryranges.constants';
class PersonalDetails extends React.Component {
  constructor(props) {
    super(props);
    this.requireSalaryAndBirthday = undefined;
    if (!props.disableBirthdayAndSalary) {
      this.requireSalaryAndBirthday = [validator.required, validator.greaterThanZero];
    }
  }

  validUniqueEmail = (value) =>
    validator.validateUniqueEmail({ user_type: 'Lead', email: value }) === undefined;

  render() {
    const { translate } = this.props;
    return (
      <Fragment>
        <div className="row" style={{ marginTop: '20px' }}>
          <input type="disable_auto_complete" value="disable_auto_complete" hidden />
          <div className="col-sm-6" style={{ textAlign: 'center' }}>
            <Field
              disabled={hostIsCapreit()}
              name="first_name"
              type="text"
              component={TextField}
              variant="outlined"
              label={translate('landlordPortal.personalDetails.firstName')}
              validate={[validator.required]}
              style={{ fontSize: '14px', width: '100%' }}
            />
          </div>
          <div className="col-sm-6" style={{ textAlign: 'center' }}>
            <Field
              disabled={hostIsCapreit()}
              name="last_name"
              type="text"
              component={TextField}
              variant="outlined"
              label={translate('landlordPortal.personalDetails.lastName')}
              validate={[validator.required]}
              style={{ fontSize: '14px', width: '100%' }}
            />
          </div>
        </div>
        <div className="row" style={{ marginTop: '20px' }}>
          <div className="col-sm-6" style={{ textAlign: 'center' }}>
            <Field
              name="email"
              type="text"
              component={TextField}
              variant="outlined"
              autoComplete="do_not_show_autocomplete"
              label={translate('landlordPortal.personalDetails.email')}
              validate={[this.validUniqueEmail]}
              style={{ fontSize: '14px', width: '100%' }}
              onBlur={(event) => {
                const value = event.target.value;
                if (!value) return;

                if (this.props.onEmailBlur) this.props.onEmailBlur(value);
              }}
            />
          </div>
          <div className="col-sm-6" style={{ textAlign: 'center' }}>
            <Field
              name="phone_number"
              type="text"
              label={translate('landlordPortal.personalDetails.phoneNumber')}
              component={ReactPhoneInput}
              validate={[validator.required, validator.validInternationalPhoneNumber]}
              style={{ fontSize: '14px' }}
            />
          </div>
        </div>
        {this._renderYearlyIncome()}
      </Fragment>
    );
  }

  _renderYearlyIncome = () => {
    if (this.props.hideSalary) return;

    return (
      <Fragment>
        <div className="row" style={{ marginTop: '20px' }}>
          <div className="col-sm-6">
            <Field
              name="yearly_income"
              component={OutlinedSelect}
              label={getTranslatedString('yearlyIncome')}
              validate={this.requireSalaryAndBirthday}
              fullWidth
              style={{ fontSize: '14px', textAlign: 'left' }}
              errorStyle={{ fontSize: '14px' }}
            >
              {SALARY_RANGES.map((range) => (
                <MenuItem value={range.integerValue}>{range.primaryText}</MenuItem>
              ))}
            </Field>
          </div>
          <div className="col-sm-6">
            <Field
              name="dob"
              maxDate={maxDate(this.props.minimumApplicantAge || 18, 'years')}
              component={DatePickerAccessible}
              variant="outlined"
              showYearDropdown
              showMonthDropdown
              dropdownMode="select"
              dateFormat="yyyy-MM-dd"
              popperPlacement="top-end"
              formatDate={formatter.reformatDate}
              validate={this.requireSalaryAndBirthday}
              autoOk={true}
              style={{ fontSize: '14px' }}
              textFieldStyle={{ fontSize: '14px', width: '100%' }}
              label="Вirthday"
            />
          </div>
        </div>
        {!this.props.hideSIN && this.props.collectLeadSinNumberDuringApplication ? (
          <div className="row" style={{ marginBottom: '25px' }}>
            <div className="col-sm-6">
              <SinNumberFormField />
            </div>
          </div>
        ) : null}
        <div
          className="row"
          style={{
            textAlign: 'center',
            marginTop: '20px',
            marginBottom: '25px',
            fontFamily: 'Circular-Bold',
          }}
        >
          <p> Is he/she a Guarantor? </p>
          <BooleanRadioButtons
            name="is_guarantor"
            style={{ width: '140px', display: 'inline-flex' }}
          />
        </div>
      </Fragment>
    );
  };
}

const mapStateToProps = (state) => ({
  isUserAdmin: deepDiver(state, 'userTypes.admin'),
});

export default connect(mapStateToProps)(localize()(PersonalDetails));
